
export const accessTokenMap = "pk.eyJ1IjoibWFzbG92YXkiLCJhIjoiY2t4cHI2bzA0MGNrdjJwbzJpN2k0eDIyYyJ9.L5YHGuIXWBqxG3XMXeQC7Q";
//export const apiURL = "https://localhost:5001/api/Map/";
//export const apiURL = "https://api.uberu.club/api/Map/";
//export const apiURL = "http://10.11.13.43:5001/api/Map/"
export const apiURL = "https://uberuapp.reo.ru/api/map/";
//export const apiURL = "https://localhost:5027/api/map/";

export const apiURLTb = "https://app.trashback.net/api/Map/";

export const apiKeyYandex = "aebf5d08-d271-4619-bc9d-328b0b1656c2";
export const geoSuggetKeyYandex = "75af4e8e-68d9-4c78-83c6-edd87b62dd5f";

export const wasteTypes = [
    { value: 'wPet', label: 'ПЭТ-бутылки' },
    { value: 'wPlastic', label: 'Пластик' },
    { value: 'wAluminium', label: 'Алюминиевые банки' },
    { value: 'wGlass', label: 'Стекло' },
    { value: 'wCaps', label: 'Крышечки' },
    { value: 'wPaper', label: 'Бумага/картон' },
    { value: 'wMetall', label: 'Черный металл' },
    { value: 'wMetallColoured', label: 'Цветной металл' },
    { value: 'wWear', label: 'Одежда' },
    { value: 'wShoes', label: 'Обувь' },
    { value: 'wBatteries', label: 'Батарейки' },
    { value: 'wLamps', label: 'Лампы' },
    { value: 'wDangerous', label: 'Опасные отходы' },
    { value: 'wAppliances', label: 'Бытовая техника' },
    { value: 'wTetrapak', label: 'Тетрапак' },
    { value: 'wTyres', label: 'Шины' }
  ];
  
export const deviceTypes = [
    { value: 1, label: 'Контейнер' },
    { value: 2, label: 'Пункт приема (с сотрудником)' },
    { value: 3, label: 'Автоматический пункт/фандомат' }
  ];

export const defaultLat = 55.7558;
export const defaultLng = 37.6173;
export const defaultZoom = 12; 

export const uberuMainColor = "#sdfdsf";
export const uberuGreenColor = "#116062";
export const uberuLightGreenColor = "#47B972";
export const uberuLightGreen2Color = "#E0F6F6";
export const uberuRedColor = "#D21235";

export const uberuLightColor = "#ECF5F8";
export const uberuTextColor = "#3D3E4D";
export const uberuLightColor2 = "#AEDADB";
export const uberuBorderColor = "#A1A3B5";


export const uberuPointTypes = [
  {
      Name: "На улице",
      Id: 1
  },
  {
      Name: "Отдельное здание",
      Id: 2
  },
  {
      Name: "Автоматический",
      Id: 3
  },
  {
      Name: "В помещении",
      Id: 4
  },
  {
      Name: "Экоцентр",
      Id: 5
  },
  {
      Name: "Мобильный",
      Id: 6
  },
]

export const uberuWasteTypes = [
  {
      Name: "wPet",
      NameDb: "WPet",
      Description: "ПЭТ",
      Id: 1
  },
  {
      Name: "wPlastic",
      NameDb: "WPlastic",
      Description: "Пластик",
      Id: 2
  },
  
  {
      Name: "wMetall",
      NameDb: "WMetall",
      Description: "Металл",
      Id: 3
  },
  {
      Name: "wCaps",
      NameDb: "WCaps",
      Description: "Крышечки",
      Id: 4
  },
  {
      Name: "wGlass",
      NameDb: "WGlass",
      Description: "Стекло",
      Id: 5
  },
  {
      Name: "wAluminium",
      NameDb: "WAluminium",
      Description: "Алюминий",
      Id: 6
  },
  {
      Name: "wPaper",
      NameDb: "WPaper",
      Description: "Бумага",
      Id: 7
  },
  {
      Name: "wBatteries",
      NameDb: "WBatteries",
      Description: "Батарейки",
      Id: 8
  },
  {
      Name: "wDangerous",
      NameDb: "WDangerous",
      Description: "Опасные",
      Id: 9
  },
  {
      Name: "wAppliances",
      NameDb: "WAppliances",
      Description: "Быт техника",
      Id: 10
  },
  {
      Name: "wWear",
      NameDb: "WWear",
      Description: "Одежда",
      Id: 11
  },
  {
      Name: "wShoes",
      NameDb: "WShoes",
      Description: "Обувь",
      Id: 12
  },
  {
      Name: "wLamps",
      NameDb: "WLamps",
      Description: "Лампы",
      Id: 13
  },
  {
      Name: "wTetrapak",
      NameDb: "WTetrapak",
      Description: "Тетрапак",
      Id: 14
  },
  {
      Name: "wTyres",
      NameDb: "WTyres",
      Description: "Шины",
      Id: 15
  },
  {
      Name: "wMedicine",
      NameDb: "WMedicine",
      Description: "Медотходы",
      Id: 16
  },
  {
      Name: "wOther",
      NameDb: "WOther",
      Description: "Другое",
      Id: 17
  }
]


export const emptyDataPoint = {
    Id: null,
    Name: "",
    Lng: 55.7558,
    Lat: 37.6173,
    Description: "",
    Address: "",
    Comment: "",
    CompanyName: "",
    Email: "",
    Phone: "",
    Type: 1,
    Web: "",
    WAluminium: false,
    WAppliances: false,
    WBatteries: false,
    WDangerous: false,
    WGlass: false,
    WLamps: false,
    WMetall: false,
    WWear: false,
    WCaps: false,
    WMetallColoured: false,
    WPet: false,
    WPlastic: false,
    WTetrapak: false,
    WTyres: false,
    WPaper: false
  };
  